import Vue from 'vue';
import { getters } from '@/modules/core/app/helpers/store';
import { Module } from '@/modules/core/app/constants/app.constants';

Vue.prototype.$hasPermission = (moduleName, permissionKey) =>
  getters.export.isExporting() ||
  getters.session.getUserSettings().hasPermission(moduleName, permissionKey);

Vue.prototype.$hasPermissionToRead = (moduleName, permissionKey) =>
  getters.export.isExporting() ||
  getters.session.getUserSettings().hasPermissionToRead(moduleName, permissionKey);

Vue.prototype.$hasPermissionToWrite = (moduleName, permissionKey) =>
  getters.export.isExporting() ||
  getters.session.getUserSettings().hasPermissionToWrite(moduleName, permissionKey);

Vue.prototype.$module = Module;
